// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMobileFirstPath = 'M9 89.5c0 5.799 4.701 10.5 10.5 10.5h45c5.799 0 10.5-4.701 10.5-10.5V72h-7v17.5a3.5 3.5 0 01-3.5 3.5h-45a3.5 3.5 0 01-3.5-3.5v-79A3.5 3.5 0 0119.5 7H31l4.6 6h12.8L53 7h11.5a3.5 3.5 0 013.5 3.5V22h7V10.5C75 4.701 70.299 0 64.5 0h-45C13.701 0 9 4.701 9 10.5v79zm33-.5a5 5 0 100-10 5 5 0 000 10zm18.1-32h19.2a8.1 8.1 0 007.6-5.3L96.2 26H50.4l-.2-.6a8.1 8.1 0 00-7.6-5.4H36v7h6.6a1.1 1.1 0 011 .8l8.9 23.9a8.1 8.1 0 007.6 5.3zm-1-7.7L53 33h33.2l-5.9 16.3a1.1 1.1 0 01-1 .7H60.1a1.1 1.1 0 01-1-.7zM64 64.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM80.5 69a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM22 35h21v7H22v-7zm25 11H29v7h18v-7z';
var IllustrationMobileFirst = baseIllustration('IllustrationMobileFirst', {
  getPath: () => IllustrationMobileFirstPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMobileFirst;
//# sourceMappingURL=index.js.map